import { useDocumentTitle } from "Utilities";
import { Helmet } from "react-helmet";

export type DocumentTitleProps = {
  subTitle: string;
  nestRoutes?: boolean;
  clearOnDismount?: boolean;
};

export const DocumentTitle = ({
  subTitle,
  nestRoutes,
  clearOnDismount,
}: DocumentTitleProps) => {
  const title = useDocumentTitle(subTitle, nestRoutes, clearOnDismount);
  
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};
